import { h, resolveComponent } from 'vue'

import NewAdminLayout from "@/layouts/NewAdminLayout.vue";
import StoreNew from "@/views/cards/StoreNew.vue";

export default
{
  path: '/panel',
  name: 'Panel',
  props: {
    label: 'خانه',
  },
  meta: {
    requiresAuth: true,
  },
  component: NewAdminLayout,
  redirect: '/admin/dashboard',
  children: [
    {
      path: 'payment_able',
      name: 'NewPaymentAble',
      redirect: '/panel/payment_able/list',
      props: {
        label: 'پرداختنی ها',
      },
      component: {
        render() {
          return h(resolveComponent('router-view'))
        },
      },
      children: [
        {
          path: 'list',
          name: 'NewPaymentAbleList',
          props: {
            label: 'لیست پرداختنی ها',
          },
          component: () => import('@/views/paymentable/index.vue'),
        },
      ],
    },
    {
      path: 'card',
      redirect: '/panel/card/new-list',
      props: {
        label: 'سفارش ها',
      },
      component: {
        render() {
          return h(resolveComponent('router-view'))
        },
      },
      children: [
        {
          path: 'new-list',
          name: 'NewOrdersList',
          props: {
            label: 'لیست سفارش ها',
          },
          component: () => import('@/views/orders/new/index.vue'),
        },
      ],
    }
  ],
}

